module.exports = __webpack_public_path__ + "img/calendar.72de2493.png";